import { formatRoleName } from '../../../common';
import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { formatScopeName, formatViewName, getRoleNames, getScopeName, getViewName, rolesDivider, } from '../../utils/nameFormat';
const articleList = getViewName({ entityName: 'Article', viewType: 'dataGrid' });
const articleScope = getScopeName({ entityName: 'Article' });
export const aclAllowScopeStmtInstruction = `
#### Allowing access to entities
- Syntax: \`allow <role1>[, <role2>] scope <viewName>.<scopeName>;\`
- Example: \`allow ${getRoleNames('user')} scope ${articleList}.${articleScope};\`
- Example: \`allow ${getRoleNames('editor')} scope ${articleList}.${articleScope};\`
- Example: \`allow ${getRoleNames('public', 'editor')} scope ${articleList}.${articleScope};\`
`;
export const stmtAclAllowScope = ({ roles, viewName, scopeName }) => {
    return `allow ${roles.join(rolesDivider)} scope ${viewName}.${scopeName};`;
};
export const aclAllowScopeHandler = createStructureStatementHandler({
    type: 'allow scope',
    parse: line => {
        const match = /^allow (?<roles>[\w, ]+) scope (?<viewName>\w+).(?<scopeName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'allow scope',
                roles: match.groups.roles.split(',').map(it => formatRoleName(it.trim())),
                viewName: formatViewName(match.groups.viewName),
                scopeName: formatScopeName(match.groups.scopeName),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => it.allowScope({ roles: stmt.roles, scopeName: stmt.scopeName, viewName: stmt.viewName }));
    },
});
//# sourceMappingURL=AllowRoleScopeStmt.js.map